import { startMemberKakaoOAuth } from '@/api/member'

export function kakaoRedirectUri() {
  return `${window.location.origin}/oauth/kakao`
}

export async function startKakaoLogin(options?: {
  redirect?: string
  remember?: boolean
}) {
  const result = await startMemberKakaoOAuth({
    redirectUri: kakaoRedirectUri(),
    redirect: options?.redirect || '',
    remember: options?.remember === true,
  })
  window.location.assign(result.url)
}
